module.exports = __webpack_public_path__ + "static/media/phone-icon-footer.4676b2f4.svg";